"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.cosmosCreateMessage = void 0;
var promise_1 = require("../../promise");
var getAmount = function (core, currency, amount) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, core.CosmosLikeAmount.init(amount, currency.id === "cosmos_testnet" ? "umuon" : "uatom")];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var cosmosCreateMessage = function (freshAddress, transaction, core, currency) { return __awaiter(void 0, void 0, void 0, function () {
    var recipient, _a, _b, _c, _d, _e, _f, validators, validators, cosmosSourceValidator_1, validators, validators, validators, _g, _h;
    return __generator(this, function (_j) {
        switch (_j.label) {
            case 0:
                recipient = transaction.recipient;
                _a = transaction.mode;
                switch (_a) {
                    case "send": return [3 /*break*/, 1];
                    case "delegate": return [3 /*break*/, 5];
                    case "undelegate": return [3 /*break*/, 7];
                    case "redelegate": return [3 /*break*/, 9];
                    case "claimReward": return [3 /*break*/, 11];
                    case "claimRewardCompound": return [3 /*break*/, 13];
                }
                return [3 /*break*/, 16];
            case 1:
                _c = (_b = core.CosmosLikeMessage).wrapMsgSend;
                _e = (_d = core.CosmosLikeMsgSend).init;
                _f = [freshAddress, recipient];
                return [4 /*yield*/, getAmount(core, currency, transaction.amount.toString())];
            case 2: return [4 /*yield*/, _e.apply(_d, _f.concat([[
                        _j.sent()
                    ]]))];
            case 3: return [4 /*yield*/, _c.apply(_b, [_j.sent()])];
            case 4: return [2 /*return*/, [
                    _j.sent()
                ]];
            case 5:
                validators = transaction.validators;
                if (!validators || validators.length === 0) {
                    throw new Error("no validators");
                }
                return [4 /*yield*/, (0, promise_1.promiseAllBatched)(2, validators, function (validator) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a, _b, _c, _d, _e;
                        return __generator(this, function (_f) {
                            switch (_f.label) {
                                case 0:
                                    _b = (_a = core.CosmosLikeMessage).wrapMsgDelegate;
                                    _d = (_c = core.CosmosLikeMsgDelegate).init;
                                    _e = [freshAddress,
                                        validator.address];
                                    return [4 /*yield*/, getAmount(core, currency, validator.amount.toString())];
                                case 1: return [4 /*yield*/, _d.apply(_c, _e.concat([_f.sent()]))];
                                case 2: return [4 /*yield*/, _b.apply(_a, [_f.sent()])];
                                case 3: return [2 /*return*/, _f.sent()];
                            }
                        });
                    }); })];
            case 6: return [2 /*return*/, _j.sent()];
            case 7:
                validators = transaction.validators;
                if (!validators || validators.length === 0) {
                    throw new Error("no validators");
                }
                return [4 /*yield*/, (0, promise_1.promiseAllBatched)(2, validators, function (validator) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a, _b, _c, _d, _e;
                        return __generator(this, function (_f) {
                            switch (_f.label) {
                                case 0:
                                    _b = (_a = core.CosmosLikeMessage).wrapMsgUndelegate;
                                    _d = (_c = core.CosmosLikeMsgUndelegate).init;
                                    _e = [freshAddress,
                                        validator.address];
                                    return [4 /*yield*/, getAmount(core, currency, validator.amount.toString())];
                                case 1: return [4 /*yield*/, _d.apply(_c, _e.concat([_f.sent()]))];
                                case 2: return [4 /*yield*/, _b.apply(_a, [_f.sent()])];
                                case 3: return [2 /*return*/, _f.sent()];
                            }
                        });
                    }); })];
            case 8: return [2 /*return*/, _j.sent()];
            case 9:
                cosmosSourceValidator_1 = transaction.cosmosSourceValidator;
                if (!cosmosSourceValidator_1) {
                    throw new Error("source validator is empty");
                }
                validators = transaction.validators;
                if (!validators || validators.length === 0) {
                    throw new Error("no validators");
                }
                return [4 /*yield*/, (0, promise_1.promiseAllBatched)(2, validators, function (validator) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a, _b, _c, _d, _e;
                        return __generator(this, function (_f) {
                            switch (_f.label) {
                                case 0:
                                    _b = (_a = core.CosmosLikeMessage).wrapMsgBeginRedelegate;
                                    _d = (_c = core.CosmosLikeMsgBeginRedelegate).init;
                                    _e = [freshAddress,
                                        cosmosSourceValidator_1,
                                        validator.address];
                                    return [4 /*yield*/, getAmount(core, currency, validator.amount.toString())];
                                case 1: return [4 /*yield*/, _d.apply(_c, _e.concat([_f.sent()]))];
                                case 2: return [4 /*yield*/, _b.apply(_a, [_f.sent()])];
                                case 3: return [2 /*return*/, _f.sent()];
                            }
                        });
                    }); })];
            case 10: return [2 /*return*/, _j.sent()];
            case 11:
                validators = transaction.validators;
                if (!validators || validators.length === 0) {
                    throw new Error("no validators");
                }
                return [4 /*yield*/, (0, promise_1.promiseAllBatched)(2, validators, function (validator) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    _b = (_a = core.CosmosLikeMessage).wrapMsgWithdrawDelegationReward;
                                    return [4 /*yield*/, core.CosmosLikeMsgWithdrawDelegationReward.init(freshAddress, validator.address)];
                                case 1: return [4 /*yield*/, _b.apply(_a, [_c.sent()])];
                                case 2: return [2 /*return*/, _c.sent()];
                            }
                        });
                    }); })];
            case 12: return [2 /*return*/, _j.sent()];
            case 13:
                validators = transaction.validators;
                if (!validators || validators.length === 0) {
                    throw new Error("no validators");
                }
                _g = [[]];
                return [4 /*yield*/, (0, promise_1.promiseAllBatched)(2, validators, function (validator) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    _b = (_a = core.CosmosLikeMessage).wrapMsgWithdrawDelegationReward;
                                    return [4 /*yield*/, core.CosmosLikeMsgWithdrawDelegationReward.init(freshAddress, validator.address)];
                                case 1: return [4 /*yield*/, _b.apply(_a, [_c.sent()])];
                                case 2: return [2 /*return*/, _c.sent()];
                            }
                        });
                    }); })];
            case 14:
                _h = [__spreadArray.apply(void 0, _g.concat([__read.apply(void 0, [(_j.sent())]), false]))];
                return [4 /*yield*/, (0, promise_1.promiseAllBatched)(2, validators, function (validator) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a, _b, _c, _d, _e;
                        return __generator(this, function (_f) {
                            switch (_f.label) {
                                case 0:
                                    _b = (_a = core.CosmosLikeMessage).wrapMsgDelegate;
                                    _d = (_c = core.CosmosLikeMsgDelegate).init;
                                    _e = [freshAddress,
                                        validator.address];
                                    return [4 /*yield*/, getAmount(core, currency, validator.amount.toString())];
                                case 1: return [4 /*yield*/, _d.apply(_c, _e.concat([_f.sent()]))];
                                case 2: return [4 /*yield*/, _b.apply(_a, [_f.sent()])];
                                case 3: return [2 /*return*/, _f.sent()];
                            }
                        });
                    }); })];
            case 15: return [2 /*return*/, __spreadArray.apply(void 0, _h.concat([__read.apply(void 0, [(_j.sent())]), false]))];
            case 16: throw new Error("unknown message : ".concat(transaction.mode));
        }
    });
}); };
exports.cosmosCreateMessage = cosmosCreateMessage;
//# sourceMappingURL=message.js.map